<template>
  <div style="padding-top:40px">
    <div :style="'background-image:url('+oss+data.style.icon+');background-repeat: no-repeat;background-size:100% auto'" class="main">
      <div class="btn" :style="'background-size:100%;background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">
        继续扫码
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "success",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 300px;
  height: 290px;
  background-size: contain;
  margin: 0 auto;
  position: relative;
  .btn {
    background-color: #ff211d;
    color: #fff;
    width: 235px;
    border-radius: 20px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    position: absolute;
    bottom: 18px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>